/**
 * Assist mode — the visit total, typed straight in.
 *
 * The faster of the two modes and the default, because a marker who can add
 * up three darts in their head is doing it before they reach the tablet. Dart
 * count is unknowable here, so a checkout has to ask (CheckoutModal); Manual
 * mode knows and does not.
 */

const KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];

/** Three treble twenties. Nothing above this is a visit. */
const MAX_VISIT = 180;

export default function AssistKeypad({ entry, onEntry, onSubmit, disabled }) {
  const value = Number(entry);
  const valid = entry !== '' && Number.isInteger(value) && value >= 0 && value <= MAX_VISIT;

  const press = (key) => {
    // Leading zeros would let "007" through as seven and read as a typo the
    // marker cannot see. One zero is a legitimate visit; a zero in front of
    // anything is not.
    const next = entry === '0' ? key : `${entry}${key}`;
    if (Number(next) > MAX_VISIT) return;
    onEntry(next);
  };

  return (
    <div className="hd-keypad">
      <div className="hd-keypad-display" aria-live="polite">
        {entry === '' ? <span className="hd-muted">Score</span> : entry}
      </div>

      <div className="hd-keypad-grid">
        {KEYS.map((key) => (
          <button
            key={key}
            type="button"
            className="hd-key"
            disabled={disabled}
            onClick={() => press(key)}
          >
            {key}
          </button>
        ))}

        <button
          type="button"
          className="hd-key hd-key-quiet"
          disabled={disabled || entry === ''}
          onClick={() => onEntry('')}
        >
          Clear
        </button>

        <button
          type="button"
          className="hd-key hd-key-go"
          disabled={disabled || !valid}
          onClick={() => onSubmit(value)}
        >
          Enter
        </button>
      </div>
    </div>
  );
}
